<template>
  <div class="goodBox" @click="toDetail">
    <div class="imgbox img">
      <img v-if="item[sname[showType].coverImage]" :src="item[sname[showType].coverImage]+sname[showType].after" alt="">
    </div>
    <div class="text pub_left">
      <p class=" pub_left f14 two_line" style="width: 100%;">
        <img v-if="item.user_type==='0'" src="../assets/image/common/taobao.png" alt="" class="biaoshi">
        <img v-if="item.user_type==='1'" src="../assets/image/common/tianmao.png" alt="" class="biaoshi">
        <img v-if="showType==='pdd'" src="../assets/image/common/pinduoduo.png" alt="" class="biaoshi">
        <img v-if="showType==='jd'" src="../assets/image/common/jingdong.png" alt="" class="biaoshi">
        <img v-if="showType==='1'" src="../assets/image/common/yundian.png" alt="" class="biaoshi">
        <img v-if="showType==='wph'" src="../assets/image/common/weipinhui.png" alt="" class="biaoshi">
        {{item[sname[showType].productName]}}
      </p>
      <p class="flex flex_start">
        <span v-if="showType==='jd'" class="price f16 main_co" :style="{'font-weight': 'bold'}">￥{{item.price}}</span>
        <span v-else-if="showType==='pdd'" class="price f16 main_co" :style="{'font-weight': 'bold'}">￥{{item[sname[showType].price]?(item[sname[showType].price]*sname[showType].pricepoint-item[sname[showType].couponMoney]*sname[showType].pricepoint).toFixed(2):''}}</span>
        <span v-else class="price f16 main_co" :style="{'font-weight': 'bold'}">￥{{item[sname[showType].price]?(item[sname[showType].price]*sname[showType].pricepoint).toFixed(2):item.priceInfo.lowestPrice}}</span>
        <span class="oldprice trans f12 gray_f" :style="{'transform': 'scale('+ scale +')'}">￥{{item[sname[showType].originalPrice]?(item[sname[showType].originalPrice]*sname[showType].pricepoint).toFixed(2):item.oriPrice}}</span>
      </p>
      <p class="num f12 trans1 gray_f">已售 {{item[sname[showType].salesVolume]}}</p>
      <div class="bot" v-if="ptype==='1'">
        <div>
          <span v-if="showType==='jd'" class="ticket f14 trans white_f">{{item.coupon}}元券</span>
          <span v-else class="ticket f14 trans white_f" :style="{'transform': 'scale('+ scale +')'}">{{(item[sname[showType].couponMoney]*sname[showType].pricepoint).toFixed(0)}}元券</span>
        </div>
        <div>
          <span v-if="showType==='pdd'" class="f14 trans beneif" :style="{'transform': 'scale('+ scale +')'}">
            {{(parseInt(item[sname[showType].rate]*1*((item[sname[showType].price]*1-item[sname[showType].couponMoney]*1)*sname[showType].zkrate*sname[showType].pricepoint)/(sname[showType].point)*100)*0.01).toFixed(2)}}铜板
          </span>
          <span v-else-if="showType==='jd'" class="f14 trans beneif" :style="{'transform': 'scale('+ scale +')'}">{{item.tongBan}}铜板</span>
          <span v-else class="f14 trans beneif" :style="{'transform': 'scale('+ scale +')'}">{{item[sname[showType].integral]?(parseInt(item[sname[showType].integral]*1*sname[showType].zkrate*100)*0.01).toFixed(2):(parseInt(item[sname[showType].rate]*1*(item[sname[showType].price]*sname[showType].zkrate*sname[showType].pricepoint)/(sname[showType].point*1)*100)*0.01).toFixed(2)}}铜板</span>
        </div>
      </div>
      <div class="flex bot space_between" v-else>
        <span v-if="showType==='jd'" class="ticket f12 trans white_f">{{item.coupon}}元券</span>
        <span v-else class="ticket f12 trans white_f" :style="{'transform': 'scale('+ scale +')'}">{{(item[sname[showType].couponMoney]*sname[showType].pricepoint).toFixed(0)}}元券</span>
        <span v-if="showType==='pdd'" class="f12 trans beneif" :style="{'transform': 'scale('+ scale +')'}">{{(parseInt(item[sname[showType].rate]*1*((item[sname[showType].price]*1-item[sname[showType].couponMoney]*1)*sname[showType].zkrate*sname[showType].pricepoint)/(sname[showType].point)*100)*0.01).toFixed(2)}}铜板</span>
        <span v-else-if="showType==='jd'" class="f12 trans beneif" :style="{'transform': 'scale('+ scale +')'}">{{item.tongBan}}铜板</span>
        <span v-else class="f12 trans beneif" :style="{'transform': 'scale('+ scale +')'}">{{item[sname[showType].integral]?(parseInt(item[sname[showType].integral]*1*sname[showType].zkrate*100)*0.01).toFixed(2):(parseInt(item[sname[showType].rate]*1*(item[sname[showType].price]*sname[showType].zkrate*sname[showType].pricepoint)/(sname[showType].point*1)*100)*0.01).toFixed(2)}}铜板</span>
      </div>
    </div>
  </div>
</template>

<script>
import {getpdditemtgurl} from '../api/home'
export default {
  props: {
    ptype: String, // 排版
    type: String, // 类型 1-云店
    item: Object,
    showType: {
      type: String,
      default () {
        return '1'
      }
    },
    scale: {
      type: Number,
      default () {
        return 1
      }
    }
  },
  data () {
    return {
      icon: require('../assets/logo.png')
    }
  },
  methods: {
    toDetail () {
      // if (this.showType === 'pdd') {
      //   getpdditemtgurl({productId: this.item.goods_id, uid: localStorage.getItem('uid')}).then(res => {
      //     if (res.result === '0') {
      //       this.$dialog.confirm({
      //         title: '提示',
      //         message: '是否离开跳转拼多多？',
      //         confirmButtonColor: this.m_color
      //       }).then(() => {
      //         window.location.href = res.dataList[0].mobile_url
      //       })
      //     }
      //   })
      // } else {
        this.$router.push({path: '/goodDetail', query: {type: this.type, productId: this.item[this.sname[this.showType].productId], productSign: this.item[this.sname[this.showType].productSign],category_id: this.item[this.sname[this.showType].category_id], showType: this.showType, suid: localStorage.getItem('uid') ? localStorage.getItem('uid') : ''}})
      // }
    }
  }
}
</script>

<style scoped>
.goodBox{
  margin: 4% 2.5%;
}
.img{
  width: 100%;
  padding-top: 100%;
  /*background-image: url("../assets/logo.png");*/
  /*background-size: cover;*/
}
.text{
  font-size: 0;
  margin-top: .1rem;
}
  .trans{
    display: inline-block;
    transform-origin: left bottom;
  }
  .trans1{
    display: inline-block;
    transform-origin: left top;
  }
  .price{
  }
  .oldprice{
    text-decoration: line-through;
    margin-left: .2rem;
  }
  .ticket{
    line-height: 1;
    background: #F03A17;
    border-radius: .1rem;
    padding: 3px .1rem;/*no*/
  }
  .beneif{
    border-radius: .1rem;
    margin-left: .1rem;
    /*background: #ffe8e0;*/
  }
  .bot span{
    margin-top: .1rem;
  }
.biaoshi{
  height: 14px;
  line-height: .6rem;
  vertical-align: top;
  /*margin-right: .1rem;*/
  margin-top: .1rem;
}
  .two_line{
    display: inline-block;
    max-height: 3em;
    overflow: hidden;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/goodCard.vue